export const DEFAULT_VENDOR_ID_KEY = "SID";
// 2 hours.
export const DEFAULT_EXPIRATION_TIME_IN_MINUTES = 2 * 60;
